export default "__VITE_ASSET__BWMm$rEC__"